import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { _HttpClient } from '@delon/theme';

export interface StatusOption {
  value: number;
  label: string;
  color: string;
}

@Component({
  selector: 'app-status-multi-select',
  template: `
    <nz-select
      *ngIf="parkAndPost"
      [nzMode]="'multiple'"
      [nzPlaceHolder]="placeholder"
      [nzAllowClear]="true"
      [nzShowSearch]="true"
      [nzLoading]="loading"
      [(ngModel)]="selectedValues"
      (ngModelChange)="onChange($event)"
      [nzDisabled]="disabled"
    >
      <ng-container *ngFor="let o of statusOptions">
        <nz-option [nzValue]="o.value" [nzLabel]="o.label" nzCustomContent>
          <span> {{ o.label }}</span>
        </nz-option>
      </ng-container>
    </nz-select>
  `,
  styles: [
    `
      :host ::ng-deep {
        .ant-select-selection-item {
          padding: 0 8px;
        }
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class StatusMultiSelectComponent implements OnInit {
  @Input() label = 'Status';
  @Input() labelSpan = 1;
  @Input() placeholder = 'Select status';
  @Input() disabled = false;
  @Input() errorTip = '';
  @Input() selectedValues: number[] = [];
  @Output() readonly selectedValuesChange = new EventEmitter<number[]>();
  @Output() readonly isParkAndPostChange = new EventEmitter<boolean>();

  loading = false;
  parkAndPost: boolean = false;
  statusOptions: StatusOption[] = [
    { value: 0, label: 'Draft', color: '#FA9D94' },
    { value: 1, label: 'Waiting for Approval', color: '#f7e9a9' },
    { value: 2, label: 'Approved', color: '#b7eb8f' }
  ];

  constructor(private http: _HttpClient) {}

  ngOnInit() {
    this.loadStatusOptions();
  }

  private async loadStatusOptions() {
    this.loading = true;
    try {
      this.http
        .get<boolean>('api/SystemData/GetParkAndPostSetting')
        .subscribe(res => {
          this.parkAndPost = res;
          this.isParkAndPostChange.emit(res);
          if (res) {
            this.selectedValues = [0, 1, 2];
          } else {
            this.selectedValues = [];
          }
        });
    } catch (error) {
      console.error('Error loading status options:', error);
    } finally {
      this.loading = false;
    }
  }

  onChange(values: number[]) {
    this.selectedValues = values;
    this.selectedValuesChange.emit(values);
  }
}
